import styles from "./resource-field.module.css";

import { Form, Button, Tag, Tooltip } from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";
import CloseIcon from "@/icons/CloseIcon";

const buildObjectOptions = (objects = []) =>
  objects.map((obj) => ({
    value: obj.uuid,
    label: (
      <div className={styles.objectOptionRow}>
        <span>{obj.name}</span>

        {obj.unit?.name && (
          <Tooltip title={obj.unit?.name}>
            <Tag className={styles.objectUnitTag}>{obj.unit.name}</Tag>
          </Tooltip>
        )}
      </div>
    ),
    searchLabel: `${obj.name} ${obj.unit?.name ?? ""}`,
  }));

const ResourceField = ({
  form,
  field,
  fieldsCount,
  definitionsOptions,
  objectsOptionsMap,
  fetchObjectsOptionsForField,
  setObjectsOptionsMap,
  remove,
}) => {
  const definitionValue = Form.useWatch(
    ["resources", field.name, "definition"],
    form,
  );

  return (
    <div key={field.key} className={styles.resourceFieldContainer}>
      <Form.Item
        {...field}
        name={[field.name, "definition"]}
        label="Тип ресурса"
        rules={[{ required: true, message: "Выберите тип ресурса" }]}
      >
        <CustomSelect
          placeholder="Начните вводить"
          options={definitionsOptions}
          showSearch
          fieldNames={{ value: "uuid", label: "name" }}
          optionFilterProp="name"
          onChange={(value) => {
            form.setFieldValue(["resources", field.name, "objects"], []);

            setObjectsOptionsMap((prev) => {
              const copy = { ...prev };
              delete copy[field.name];
              return copy;
            });

            fetchObjectsOptionsForField(value, field.name);
          }}
        />
      </Form.Item>

      {definitionValue && (
        <Form.Item
          name={[field.name, "objects"]}
          label="Ресурсы"
          rules={[{ required: true, message: "Выберите ресурсы" }]}
        >
          <CustomSelect
            placeholder="Начните вводить"
            options={buildObjectOptions(objectsOptionsMap[field.name] || [])}
            mode="multiple"
            showSearch
            allowClear
            optionLabelProp="label"
            optionFilterProp="searchLabel"
          />
        </Form.Item>
      )}

      {fieldsCount > 1 && (
        <Button
          color="default"
          variant="link"
          type="text"
          icon={<CloseIcon />}
          onClick={() => {
            setObjectsOptionsMap((prev) => {
              const copy = { ...prev };
              delete copy[field.name];
              return copy;
            });
            remove(field.name);
          }}
          className={styles.resourceRemoveButton}
        />
      )}
    </div>
  );
};

export default ResourceField;
